<button
  *ngIf="!showIconButton; else iconButtonTemplate"
  tuiButton
  [appearance]="appearance"
  [class]="class"
  [disabled]="disabled"
  [icon]="icon"
  [iconRight]="iconRight"
  [id]="id"
  [nativeId]="id"
  [shape]="shape"
  [showLoader]="showLoader"
  [size]="size"
  [style]="styles"
  [type]="type"
  [pseudoHover]="pseudoHover"
  (click)="handleOnClick($event)"
>
  {{ label }}
</button>

<ng-template #iconButtonTemplate>
  <button
    tuiIconButton
    [appearance]="appearance"
    [class]="class"
    [disabled]="disabled"
    [icon]="icon"
    [id]="id"
    [nativeId]="id"
    [shape]="shape"
    [showLoader]="showLoader"
    [size]="size"
    [style]="styles"
    [type]="type"
    [pseudoHover]="pseudoHover"
    (click)="handleOnClick($event)"
  ></button>
</ng-template>
